import { useStaticQuery, graphql } from 'gatsby'

export const useHeroCommonItemsQuery = () => {
  const { wp, forRatingValuePart1, forRatingValuePart2 } = useStaticQuery(graphql`
    query HeroCommonItemsQuery {
      wp {
        acfOptionsCommonItems {
          commonItems {
            heroCommonItems {
              defaultBackgroundImage {
                localFile {
                  childImageSharp {
                    gatsbyImageData(formats: WEBP, layout: FULL_WIDTH, quality: 100)
                  }
                }
              }
              wrenchImage {
                localFile {
                  childImageSharp {
                    gatsbyImageData(formats: WEBP, sizes: "(min-width: 1024px) 4vw, 10vw")
                  }
                }
              }
              wrenchImageAltText
              heroButtonText
              reviewText
              googleIcon {
                localFile {
                  childImageSharp {
                    gatsbyImageData(formats: WEBP, sizes: "(min-width: 1024px) 2vw, 9vw")
                  }
                }
              }
              buttons {
                iconType
                isItALinkOrAButton
                link {
                  title
                  url
                  target
                }
                buttonText
              }
            }
          }
        }
      }
      forRatingValuePart1: allBirdeyedata(
        filter: { id: { ne: "dummy" }, sourceType: { ne: "Direct Feedback" } }
      ) {
        nodes {
          rating
        }
      }
      forRatingValuePart2: allBirdeyedata(filter: { id: { ne: "dummy" }, rating: { ne: 0 } }) {
        nodes {
          rating
        }
      }
    }
  `)
  return { wp, forRatingValuePart1, forRatingValuePart2 }
}
